import axios from "axios";
import { NotLivestockService } from "./service";
import { keycloak } from "../../../../../lib/keycloak";
import { filtersDTO, NotZootResponseDTO } from "./dto";

export class NotLivestockServiceImpl implements NotLivestockService {

    public GetAllZootByNot(filters: filtersDTO): Promise<NotZootResponseDTO> {
        return axios.get("/api/notification-livestock", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                notificationId: filters.notificationId
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

}